import type { ComponentCommonDays } from '@edwin-group/people-graphql';
import type { KeyDate } from '../types';

export const keyDateToCalendarEvent = (keyDate: KeyDate): ComponentCommonDays => {
  return {
    name: keyDate.title,
    startDate: keyDate.startDate || '',
    endDate: keyDate.endDate || null,
    wholeMonth: keyDate.dateType === 'month_action',
    description: keyDate.description || null,
  } as ComponentCommonDays;
};
